import type { AnalyticsReport } from "@server/types/analyticsReportTypes";

type Endpoint = AnalyticsReport["endpoints"][number];
type Metric = "requests" | "audio" | "latency" | "errors";
const profiles: Record<
  string,
  { name: string; defaultMetric: Metric; order: number }
> = {
  notes: {
    name: "Note generation",
    defaultMetric: "requests",
    order: 0,
  },
  transcriptions: {
    name: "Transcription",
    defaultMetric: "audio",
    order: 1,
  },
  "sully-m1": {
    name: "Sully M1",
    defaultMetric: "latency",
    order: 2,
  },
  utils: {
    name: "Text to JSON",
    defaultMetric: "requests",
    order: 4,
  },
  models: {
    name: "Models",
    defaultMetric: "requests",
    order: 5,
  },
};
/** Stable product labels and ordering, independent of traffic volume. */
export function endpointProfile(endpoint: Endpoint) {
  return Object.hasOwn(profiles, endpoint.endpoint)
    ? profiles[endpoint.endpoint]
    : {
        name: endpoint.endpoint,
        defaultMetric: "requests" as Metric,
        order: 10,
      };
}
/** Matches the server's method-and-endpoint filter identity. */
export function endpointIdentity(endpoint: Endpoint) {
  return `${endpoint.method} ${endpoint.endpoint}`;
}
/** Aligns sparse endpoint activity to report buckets; missing latency remains null, never zero. */
export function endpointSeries(
  endpoint: Endpoint,
  buckets: AnalyticsReport["timeseries"],
) {
  const byTime = new Map(
    endpoint.timeseries?.map((bucket) => [bucket.timestamp, bucket]),
  );
  return buckets.map(
    ({ timestamp }) =>
      byTime.get(timestamp) ?? {
        timestamp,
        requests: 0,
        errors: 0,
        audioSeconds: 0,
        inputTokens: null,
        outputTokens: null,
        inputTokenRequests: 0,
        outputTokenRequests: 0,
        p50LatencyMs: null,
        p95LatencyMs: null,
      },
  );
}
